// Labels on the historical dock's bubbles (rows layout): the NAME under each bubble, which until now was only in a hover card (colour alone said what a bubble was). Pure, so it can be tested.
export const LABEL_PX = 10.5;
export const LABEL_WEIGHT = 500;
/** extra room between one row of bubbles and the next, for the label that hangs under each bubble */
export const LABEL_ROOM_Y = 20;
/** the widest a label may be before it is cut with an ellipsis; a bubble's room along a row never grows past it */
export const LABEL_MAX_WIDTH = 132;
/** the label's baseline sits this far below the bubble's lower edge */
export const LABEL_DROP = 18; // clear of the gold conversion star that hangs below a bubble's lower right
/** breathing room each side of a label, so two labels side by side never touch */
const LABEL_SIDE_PAD = 4;

export type Measure = (text: string) => number;

/** `text` cut with an ellipsis so it draws no wider than `maxWidth`; whole when it already fits. Never returns empty text for a non-empty name (at least its first letter and the ellipsis). */
export const fitLabel = (text: string, maxWidth: number, measure: Measure): string => {
  if (!text || measure(text) <= maxWidth) return text;
  let lo = 1;
  let hi = text.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (measure(text.slice(0, mid).trimEnd() + "…") <= maxWidth) lo = mid; else hi = mid - 1;
  }

  return text.slice(0, lo).trimEnd() + "…";
};

/** the room along a row a bubble with this label needs: the label's width plus a little air, never more than LABEL_MAX_WIDTH */
export const labelRoom = (labelWidth: number): number => Math.min(LABEL_MAX_WIDTH, Math.ceil(labelWidth) + 2 * LABEL_SIDE_PAD);

/** the widest a label may draw inside a room of this width */
export const labelWidthIn = (room: number): number => Math.max(0, room - 2 * LABEL_SIDE_PAD);
